module.exports = __webpack_public_path__ + "media/images/emblems/Rapperswil-Jona_CoA-ee48e025ffd74b25f0fd6b564f7c3a6b.svg";